import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { NavMenu } from './partials/nav-menu/nav-menu';
import { SearchBar } from './partials/search-bar/search-bar';
import { LangSelect } from '../../shared/components/lang-select/lang-select';
import { UserAvatarComponent } from '../../shared/components/user-avatar/user-avatar';

@Component({
  selector: 'app-main-layout',
  imports: [
    RouterOutlet,
    NavMenu,
    SearchBar,
    UserAvatarComponent,
    LangSelect
  ],
  templateUrl: './admin-layout.html',
  styleUrl: './admin-layout.scss',
  encapsulation: ViewEncapsulation.None
})
export class AdminLayout {

  breadcrumbItems: MenuItem[] = [
    { label: 'Home', routerLink: '/' },
    { label: 'Dashboard' }
  ];

}
